import { useEffect } from 'react';
import { GridFilterPanel, useGridApiContext } from '@mui/x-data-grid-pro';
import { GridLogicOperator } from '@mui/x-data-grid-pro';

// MUI's built-in "Remove all" preserves filter items whose field is not in the current
// tab's column definitions (it treats them as readOnly and keeps them in the model).
// This component overrides that behaviour so "Remove all" unconditionally clears every
// filter item, preventing stuck/undeletable rows in the filter panel.
export const CustomFilterPanel = () => {
  const apiRef = useGridApiContext();

  useEffect(() => {
    // Capture the exact unbound reference so cleanup restores it precisely.
    const original = apiRef.current.setFilterModel;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (apiRef.current as any).setFilterModel = function (
      model: Parameters<typeof original>[0],
      reason?: Parameters<typeof original>[1]
    ) {
      if (reason === 'removeAllFilterItems') {
        // Clear only filter rows; preserve quickFilterValues and any other model
        // properties so removing filters doesn't wipe the quick-search state.
        const nextModel = {
          ...(model ?? {}),
          items: [],
          logicOperator: model?.logicOperator ?? GridLogicOperator.And
        };
        return original.call(apiRef.current, nextModel, reason);
      }
      return original.call(apiRef.current, model, reason);
    };
    return () => {
      apiRef.current.setFilterModel = original;
    };
  }, [apiRef]);

  return (
    <GridFilterPanel
      sx={{
        display: 'flex',
        width: '50rem',
        paddingTop: '1rem',
        '.MuiFormControl-root': {
          marginLeft: '.5rem'
        }
      }}
    />
  );
};
